import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Col, Label, Modal, ModalBody, Row } from "reactstrap";
import { useHistory } from "react-router-dom";
import { C_Button } from "../../components/Common/CommonButton";
import * as _cfunc from "../../components/Common/CommonFunction";
import { pageId } from "../../routes/index";
import Select from "react-select";
import {
    commonPageField,
    commonPageFieldSuccess,
} from "../../store/actions";
import {
    PosDashboard_GoButton_Success,
    PosDashboard_Report_Action,
} from "../../store/Report/POSDashBoardDetailsRedux/action";
import { customAlert } from "../../CustomAlert/ConfirmDialog";
import { globalTableSearchProps } from "../../components/Common/SearchBox/MySearch";
import _debounce from "lodash/debounce";
import { allLabelWithZero } from "../../components/Common/CommonErrorMsg/HarderCodeData";
import DynamicColumnHook from "../../components/Common/TableCommonFunc";
import {
    applyAttentionSubTab,
    applyStatusFilters,
    applyVersionFilter,
    attentionSubTabOptions,
    buildSearchText,
    formatAgo,
    formatDateTimeShort,
    formatOfflineDuration,
    getSubTabChips,
    getUniqueVersionOptions,
    getVisibleBadges,
    getVersionMismatchChips,
    isUpdateRequired,
    normalizeText,
    normalizeInvoiceNo,
    getBillTimeMismatchFlags,
    getBillTimeMismatchChips,
    getBillNumberMismatchChips,
    getServiceNotWorkingGapMinutes,
    getBillTimeMismatchMaxGapMinutes,
    getMaxIssueGapMinutes,
    getDeleteChip,
    getInvoiceChip,
    getAttentionSubTabCounts,
} from "./posDashboard.logic";
import {
    clientIdBadgeStyle,
    clientIdRowStyle,
    colors,
    createdOnIconStyle, createdOnLabelStyle, createdOnListStyle, deleteMismatchCardStyle,
    deleteMismatchMessageStyle, emptyStateStyle, emptyStateSuccessStyle, filterCardStyle,
    filterFieldLabelStyle, getCreatedOnBadgeStyle, getRowCardStyle,
    getRowStatusIconWrapStyle,
    getStatusBadgeDetailedStyle,
    getStatusBadgeStyle, getStatusIconClass, getStatusIconStyle, getStatusTone, getSummaryCardAccentStyle,
    getSummaryCardStyle, getSummaryCardValueStyle, getSummaryIconChipStyle,
    getVersionCardStyle, goButtonStyle, invoiceDetailsStyle, invoiceMismatchCardStyle,
    invoiceMismatchMessageStyle, invoiceNumberStyle,
    listContainerStyle, modalBodyWrapStyle,
    modalChipsRowStyle, modalCloseButtonStyle, modalHeaderStyle, modalSectionTitleStyle,
    modalTitleStyle, partySelectStyles, rowCardChipsStyle,
    rowCardHoverStyle, rowCardLeftStyle, rowCardMacStyle, rowCardNameStyle,
    rowChevronStyle, serverMachineCheckboxStyle,
    serverMachineLabelStyle, statusBadgeDetailTextStyle, statusBadgeTopRowStyle, statusSelectStyles, summaryCardDescStyle, summaryCardHoverStyle,
    summaryCardLabelStyle, summaryCardTextWrapStyle,
    summaryStripStyle, tableCardStyle, updateRequiredStyle,
    versionDetailsStyle, versionLabelChipStyle, versionOkStyle, versionValueStyle,
} from "./posDashboard.styles";


const POSDashBoard = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const isSCMParty = _cfunc.loginIsSCMParty();
    const [PartyDropdown, setPartyDropdown] = useState(allLabelWithZero);
    const [searchText, setSearchText] = useState("");
    const { userAccess, GoBtnLoading, Distributor, tableData, pageField } = useSelector(
        (state) => ({
            tableData: state.PosDashboardReducer.PosDashboard_Gobtn,
            GoBtnLoading: state.PosDashboardReducer.goBtnLoading,
            Distributor: state.CommonPartyDropdownReducer.commonPartyDropdownOption,
            userAccess: state.Login.RoleAccessUpdateData,
            pageField: state.CommonPageFieldReducer.pageField
        })
    );
    const hasSearched = tableData?.StatusCode === 200;
    const [tableColumns] = DynamicColumnHook({ pageField });
    const [showServerOnly, setShowServerOnly] = useState(false);
    const [versionFilter, setVersionFilter] = useState([]);
    // Which summary card is currently selected — doubles as the page's
    // view switcher. "attention" (default, shown as soon as results load)
    // surfaces problem machines first; "ok" / "offline" isolate a single
    // group; "all" shows everything.
    const [activeTab, setActiveTab] = useState("attention");
    // The row currently open in the detail modal (null = modal closed).
    const [attentionSubTab, setAttentionSubTab] = useState("all");
    const [okSubTab, setOkSubTab] = useState("all");
    const [selectedRow, setSelectedRow] = useState(null);
    const debounceHandleSearch = useMemo(
        () => _debounce((val) => setSearchText(val || ""), 300),
        []
    );
    useEffect(() => {
        globalTableSearchProps({ onSearch: debounceHandleSearch });
    }, []);

    // Load initial data
    useEffect(() => {
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(pageId.POS_DASHBOARD_DETAILS));

        const defaultParty =
            _cfunc.CommonPartyDropValue().value > 0
                ? _cfunc.CommonPartyDropValue()
                : allLabelWithZero;
        setPartyDropdown(defaultParty);

        dispatch(
            PosDashboard_Report_Action({
                jsonBody: JSON.stringify({ Party: Number(defaultParty.value), CompanyID: _cfunc.loginCompanyID() }),
                btnId: "Print",
            })
        );

        return () => dispatch(commonPageFieldSuccess(null));
    }, []);

    useEffect(() => {
        if (!tableData || !tableData.StatusCode) return;

        if (tableData.StatusCode === 200) return;

        if (tableData.StatusCode === 404 || tableData.StatusCode === 204) {
            customAlert({
                Type: 3,
                Message: tableData.Message || "Record not found",
            });

            dispatch(PosDashboard_GoButton_Success([]));
        }
    }, [tableData, dispatch]);

    // Access Logic
    useEffect(() => {
        let userAcc = userAccess.find(
            (inx) => `/${inx.ActualPagePath}` === history.location.pathname
        );
        if (userAcc) {
            _cfunc.breadcrumbReturnFunc({ dispatch, userAcc });
        }
    }, [userAccess]);

    useEffect(() => {
        return () => dispatch(PosDashboard_GoButton_Success([]));
    }, []);

    // Every Go click starts back on the "Needs Attention" tab, matching
    // "when the page opens/loads results, show Needs Attention first".
    useEffect(() => {
        if (hasSearched) {
            setActiveTab("attention");
            setAttentionSubTab("all");
            setOkSubTab("all");
        }
    }, [tableData]);

    useEffect(() => {
        if (activeTab !== "attention") setAttentionSubTab("all");
        if (activeTab !== "ok") setOkSubTab("all");
    }, [activeTab]);

    const partyNameMap = useMemo(() => {
        const map = {};

        (Distributor || []).forEach(p => {
            map[p.id] = p.Name;
        });

        return map;
    }, [Distributor]);

    // Machines that have been offline for 1+ day are treated as stale and
    // hidden from the dashboard entirely — this now applies to BOTH server
    // and non-server machines (previously servers were always exempt).
    // The only exception: if the machine ALSO has another real issue on top
    // of being offline (sync pending, version mismatch, ERP mismatch, etc.)
    // it stays visible regardless of how long it's been offline, since that
    // issue still needs attention. "Another issue" means anything in
    // VersionMismatchList besides the "OFFLINE" flag itself — being offline
    // alone doesn't count.
    // Everything downstream (summary counts, tab counts, filters, search)
    // is based on this already-trimmed list so the numbers always match
    // the list.
    const visibleData = useMemo(
        () => tableData?.Data || [],
        [tableData]
    );

    const allRecordsOK = useMemo(() => {
        if (visibleData.length === 0) return false;
        return visibleData.every(r => Number(r.IsOk) === 1); // was: VersionMismatchList checks
    }, [visibleData]);

    const versionOptions = useMemo(
        () => getUniqueVersionOptions(visibleData),
        [visibleData]
    );

    const versionScopedData = useMemo(() => {
        if (!versionFilter || versionFilter.length === 0) return visibleData;
        return visibleData.filter(client =>
            versionFilter.some(v => applyVersionFilter(client, v))
        );
    }, [visibleData, versionFilter]);


    // Full dataset for the "All Machines" tab — every distinct ClientID
    // returned by the server, with NO offline-hiding applied (that hiding
    // rule only applies to Needs Attention / Offline / Running OK / the
    // summary counts). The saga already groups by ClientID, so this list
    // is naturally de-duplicated — no machine can appear twice.
    const allMachinesData = useMemo(
        () => tableData?.Data || [],
        [tableData]
    );

    const allMachinesScopedData = useMemo(() => {
        if (!versionFilter || versionFilter.length === 0) return allMachinesData;
        return allMachinesData.filter(client =>
            versionFilter.some(v => applyVersionFilter(client, v))
        );
    }, [allMachinesData, versionFilter]);

    // Quick health overview computed from the FULL visible dataset (not the
    // filtered rows), so the summary strip always reflects the actual state
    // of every machine, independent of active filters.
    const summaryStats = useMemo(() => {
        const data = versionScopedData;
        const total = data.length;
        const offline = data.filter(r => Number(r.IsOffline) === 1).length;
        const ok = data.filter(r => Number(r.IsOk) === 1).length;
        const needsAttention = total - offline - ok; // was: total - ok
        return { total, offline, ok, needsAttention };
    }, [versionScopedData]);

    const serviceOnlyVisibleData = useMemo(() => {
        const syncFrequencyByClientId = new Map(
            (tableData?.Data || []).map(row => [row.ClientID, row.POSDasboardSyncFrequency])
        );

        return (tableData?.ServiceRows || []).map(row => ({
            ...row,
            POSDasboardSyncFrequency: row.POSDasboardSyncFrequency ?? syncFrequencyByClientId.get(row.ClientID),
        }));
    }, [tableData]);

    // Rows eligible for the "Needs Attention" sub-tabs: not offline, not OK.
    const attentionPoolData = useMemo(
        () => versionScopedData.filter(
            r => Number(r.IsOffline) !== 1 && Number(r.IsOk) !== 1
        ),
        [versionScopedData]
    );

    const needsAttentionTotal = attentionPoolData.length;
    const okSubTabCounts = useMemo(() => ({
        all: versionScopedData.filter(r => Number(r.IsOk) === 1).length,
        server: versionScopedData.filter(
            r => Number(r.IsOk) === 1 && Number(r.IsServerMachine) === 1
        ).length,
        nonServer: versionScopedData.filter(
            r => Number(r.IsOk) === 1 && Number(r.IsServerMachine) !== 1
        ).length,
    }), [versionScopedData]);
    // Service-only rows, version-filtered — mirrors the filtering the
    // "Service Not Working" sub-tab itself applies before its list renders.
    const serviceOnlyScopedData = useMemo(() => {
        if (!versionFilter || versionFilter.length === 0) return serviceOnlyVisibleData;
        return serviceOnlyVisibleData.filter(client =>
            versionFilter.some(v => applyVersionFilter(client, v))
        );
    }, [serviceOnlyVisibleData, versionFilter]);


    // ClientIDs in the leftover pool — used to keep the Service Not Working
    // sub-tab consistent with the same Offline/OK exclusion every other
    // sub-tab already respects.
    const attentionPoolClientIds = useMemo(
        () => new Set(attentionPoolData.map(r => r.ClientID)),
        [attentionPoolData]
    );

    // Service-only rows, scoped down to machines actually in the attention
    // pool (not offline, not OK) — prevents Service Not Working from
    // showing machines that are already Offline or Running OK elsewhere.
    const serviceNotWorkingScopedData = useMemo(
        () => serviceOnlyScopedData.filter(r => attentionPoolClientIds.has(r.ClientID)),
        [serviceOnlyScopedData, attentionPoolClientIds]
    );

    const attentionSubTabCounts = useMemo(
        () => getAttentionSubTabCounts(attentionPoolData, serviceNotWorkingScopedData),
        [attentionPoolData, serviceNotWorkingScopedData]
    );
    // Distinct machines that are neither offline nor OK — this is the
    // true "Needs Attention" total, independent of sub-tab overlaps.






    const rows = useMemo(() => {
        const isServiceSubTab = activeTab === "attention" && attentionSubTab === "serviceNotWorking";

        let clients = isServiceSubTab
            ? serviceOnlyVisibleData.filter(r => attentionPoolClientIds.has(r.ClientID))
            : activeTab === "all"
                ? allMachinesScopedData
                : versionScopedData;

        if (activeTab === "ok") {
            clients = clients.filter(client => {
                if (Number(client.IsOk) !== 1) return false;

                if (okSubTab === "server") {
                    return Number(client.IsServerMachine) === 1;
                }

                if (okSubTab === "nonServer") {
                    return Number(client.IsServerMachine) !== 1;
                }

                return true;
            });
        }

        // versionScopedData already applies the version filter for every other
        // view — this branch needs it applied separately since it doesn't go
        // through versionScopedData.
        if (isServiceSubTab && versionFilter && versionFilter.length > 0) {
            clients = clients.filter(client =>
                versionFilter.some(v => applyVersionFilter(client, v))
            );
        }

        // Service Not Working has its own self-contained rule (lastSync gap
        // only, checked below via applyAttentionSubTab) — skip the OK/offline
        // status filter here so a row can't be excluded for any reason other
        // than that gap.
        if (!isServiceSubTab) {
            clients = clients.filter(client =>
                applyStatusFilters(client, hasSearched, searchText, allRecordsOK, activeTab)
            );
        }

        if (activeTab === "attention") {
            clients = clients.filter(client => applyAttentionSubTab(client, attentionSubTab));

            // Worst-first ordering for time-based sub-tabs: the machine
            // that's been stale/overdue the longest shows at the top.
            if (attentionSubTab === "serviceNotWorking") {
                clients = [...clients].sort(
                    (a, b) => getServiceNotWorkingGapMinutes(b) - getServiceNotWorkingGapMinutes(a)
                );
            } else if (attentionSubTab === "billTimeWise") {
                clients = [...clients].sort(
                    (a, b) => getBillTimeMismatchMaxGapMinutes(b) - getBillTimeMismatchMaxGapMinutes(a)
                );
            } else if (attentionSubTab === "all") {
                clients = [...clients].sort(
                    (a, b) => getMaxIssueGapMinutes(b) - getMaxIssueGapMinutes(a)
                );
            }
        }
        // Offline tab — longest-offline-first, using the same LastSeenAt gap
        // the "Offline · Xh Ym ago" chip is built from.
        if (activeTab === "offline") {
            clients = [...clients].sort((a, b) => {
                const aGap = a.LastSeenAt ? Date.now() - new Date(a.LastSeenAt).getTime() : Infinity;
                const bGap = b.LastSeenAt ? Date.now() - new Date(b.LastSeenAt).getTime() : Infinity;
                return bGap - aGap;
            });
        }

        if (searchText) {
            const s = normalizeText(searchText);
            clients = clients.filter(client => {
                const baseMatch = buildSearchText(client, partyNameMap).includes(s);
                const versionMatch = (client.Versions || []).some(v =>
                    normalizeText(`${v.label ?? ""} ${v.running ?? ""} ${v.current ?? ""}`).includes(s)
                );
                return baseMatch || versionMatch;
            });
        }
        if (showServerOnly) {
            clients = clients.filter(c => Number(c.IsServerMachine) === 1);
        }
        return clients;
    }, [
        versionScopedData, allMachinesScopedData, serviceOnlyVisibleData, versionFilter, searchText,
        activeTab, attentionSubTab, hasSearched, allRecordsOK, partyNameMap, showServerOnly,
        attentionPoolClientIds, okSubTab,
    ]);

    // Go Button Handler
    function goButtonHandler(BtnID) {
        if (PartyDropdown == null || PartyDropdown.value == null) {
            customAlert({
                Type: 3,
                Message: "Please select Party",
            });
            return;
        }

        const payload = {
            Party: Number(PartyDropdown.value),
            CompanyID: _cfunc.loginCompanyID()
        };

        dispatch(
            PosDashboard_Report_Action({
                jsonBody: JSON.stringify(payload),
                btnId: BtnID,
            })
        );
    }


    const partyOnchange = (e) => {
        setPartyDropdown(e);
        dispatch(PosDashboard_GoButton_Success([]));
    };

    const getPartyDisplayName = (row) =>
        partyNameMap[row.Party] ||
        (Number(PartyDropdown?.value) === Number(row.Party) ? PartyDropdown.label : row.Party);

    // Does the currently configured column set include this data field?
    // Keeps the modal respecting the same admin/dynamic-column config the
    // page always has, without needing a literal table to read it from.
    const hasColumn = (dataField) => {
        if (!tableColumns || tableColumns.length === 0) return true;
        return tableColumns.some(c => c.dataField === dataField);
    };

    // ========== Row-card chips ==========
    // Deliberately minimal: only the issue(s) that actually apply to this
    // machine, collapsed to one chip per issue type — no raw dates, no
    // POS/ERP breakdown. That detail lives in the modal.
    const getRowChips = (row) => {
        const chips = [];
        const isOffline = Number(row.IsOffline) === 1;

        if (isOffline) {
            chips.push({
                text: row.LastSeenAt
                    ? `Offline · ${formatOfflineDuration(row.LastSeenAt)} ago`
                    : "Offline",
                tone: "danger",
            });
        }

        const invoiceChip = getInvoiceChip(row, activeTab === "ok");
        if (invoiceChip) chips.push(invoiceChip);
        const deleteChip = getDeleteChip(row, activeTab === "ok");
        if (deleteChip) chips.push(deleteChip);
        chips.push(...getVersionMismatchChips(row));

        if (chips.length === 0) {
            chips.push({ text: "All OK", tone: "success" });
        }

        return chips;
    };

    // ========== Modal sections ==========
    const renderCreatedOnSection = (row) => {
        const entries = [];
        if (row.PosLastSyncRaw) {
            entries.push({ isPos: true, display: formatAgo(row.PosLastSyncRaw), absolute: row.PosLastSync });
        } else if (row.PosLastSync) {
            entries.push({ isPos: true, display: row.PosLastSync, absolute: row.PosLastSync });
        }
        if (row.ServiceLastSyncRaw) {
            entries.push({ isPos: false, display: formatAgo(row.ServiceLastSyncRaw), absolute: row.ServiceLastSync });
        } else if (row.ServiceLastSync) {
            entries.push({ isPos: false, display: row.ServiceLastSync, absolute: row.ServiceLastSync });
        }

        if (entries.length === 0 && Array.isArray(row.CreatedOnList) && row.CreatedOnList.length > 0) {
            return (
                <div style={createdOnListStyle}>
                    {row.CreatedOnList.map((t, i) => (
                        <div key={i} style={getCreatedOnBadgeStyle(i === 0)}>
                            <span style={createdOnIconStyle}>
                                <i className="bx bx-time-five"></i>
                            </span>
                            <span style={createdOnLabelStyle}>{i === 0 ? "POS" : "Service"}:</span>
                            {t}
                        </div>
                    ))}
                </div>
            );
        }

        if (entries.length === 0) return null;

        return (
            <div style={createdOnListStyle}>
                {entries.map((e, i) => (
                    <div key={i} style={getCreatedOnBadgeStyle(e.isPos)} title={e.absolute || ""}>
                        <span style={createdOnIconStyle}>
                            <i className={e.isPos ? "bx bx-time-five" : "bx bx-history"}></i>
                        </span>
                        <span style={createdOnLabelStyle}>{e.isPos ? "POS" : "Service"}:</span>
                        {e.display}
                    </div>
                ))}
            </div>
        );
    };

    const renderVersionsSection = (row) => {
        if (!row.Versions?.length) return null;

        return (
            <>
                {row.Versions.map((v, i) => {
                    const updateRequired = isUpdateRequired(v.running, v.current);
                    const isPos = v.label === "POS";

                    if (!updateRequired) {
                        return (
                            <div key={i} style={getVersionCardStyle(isPos)}>
                                <span style={versionLabelChipStyle(isPos)}>{v.label}</span>
                                <span style={versionOkStyle}>
                                    <i className="bx bx-check-circle"></i>
                                    OK
                                </span>
                                <span style={versionValueStyle}>{v.running}</span>
                            </div>
                        );
                    }

                    return (
                        <div key={i} style={getVersionCardStyle(isPos)}>
                            <span style={versionLabelChipStyle(isPos)}>{v.label}</span>
                            <span style={versionDetailsStyle}>
                                <span style={versionValueStyle}>{v.running}</span>
                                <i className="bx bx-right-arrow-alt"></i>
                                <span style={versionValueStyle}>{v.current}</span>
                            </span>
                            <span style={updateRequiredStyle}>
                                <i className="bx bx-up-arrow-circle"></i>
                                Update Required
                            </span>
                        </div>
                    );
                })}
            </>
        );
    };

    const renderInvoiceMismatchSection = (row) => {
        const isServerRow = Number(row.IsServerMachine) === 1;
        if (!isServerRow) return null;

        const numberMismatch =
            normalizeInvoiceNo(row.MaxInvoiceFullInvoiceNo) !== normalizeInvoiceNo(row.ERPMaxInvoiceFullInvoiceNo);
        const { invoiceGapMismatch } = getBillTimeMismatchFlags(row);

        if (!numberMismatch && !invoiceGapMismatch) return null;

        return (
            <div style={invoiceMismatchCardStyle}>
                <div style={invoiceDetailsStyle}>
                    <div title={formatDateTimeShort(row.MaxInvoiceCreatedOn)}>
                        <strong>POS:</strong> <span>{formatAgo(row.MaxInvoiceCreatedOn)}</span>
                        {row.MaxInvoiceFullInvoiceNo && (
                            <span style={invoiceNumberStyle}>({row.MaxInvoiceFullInvoiceNo})</span>
                        )}
                    </div>
                    <div title={formatDateTimeShort(row.ERPMaxInvoiceCreatedOn)}>
                        <strong>ERP:</strong> <span>{formatAgo(row.ERPMaxInvoiceCreatedOn)}</span>
                        {row.ERPMaxInvoiceFullInvoiceNo && (
                            <span style={invoiceNumberStyle}>({row.ERPMaxInvoiceFullInvoiceNo})</span>
                        )}
                    </div>
                </div>
                <div style={invoiceMismatchMessageStyle}>
                    <i className="bx bx-error"></i>
                    {numberMismatch && invoiceGapMismatch ? "Invoice Number Mismatch & Not Synced" : numberMismatch ? "Invoice Number Mismatch" : "Invoice Not Synced"}
                </div>
            </div>
        );
    };

    const renderDeleteMismatchSection = (row) => {
        const isServerRow = Number(row.IsServerMachine) === 1;
        if (!isServerRow) return null;

        const numberMismatch =
            normalizeInvoiceNo(row.MaxDeletedInvoiceFullInvoiceNo) !== normalizeInvoiceNo(row.ERPDeleteMaxInvoiceFullInvoiceNo);
        const { deleteGapMismatch } = getBillTimeMismatchFlags(row);

        if (!numberMismatch && !deleteGapMismatch) return null;

        return (
            <div style={deleteMismatchCardStyle}>
                <div style={invoiceDetailsStyle}>
                    <div title={formatDateTimeShort(row.MaxDeletedInvoiceCreatedOn)}>
                        <strong>POS:</strong> <span>{formatAgo(row.MaxDeletedInvoiceCreatedOn)}</span>
                        {row.MaxDeletedInvoiceFullInvoiceNo && (
                            <span style={invoiceNumberStyle}>({row.MaxDeletedInvoiceFullInvoiceNo})</span>
                        )}
                    </div>
                    <div title={formatDateTimeShort(row.ERPDeleteMaxInvoiceCreatedOn)}>
                        <strong>ERP:</strong> <span>{formatAgo(row.ERPDeleteMaxInvoiceCreatedOn)}</span>
                        {row.ERPDeleteMaxInvoiceFullInvoiceNo && (
                            <span style={invoiceNumberStyle}>({row.ERPDeleteMaxInvoiceFullInvoiceNo})</span>
                        )}
                    </div>
                </div>
                <div style={deleteMismatchMessageStyle}>
                    <i className="bx bx-error"></i>
                    {numberMismatch && deleteGapMismatch
                        ? "Delete Number Mismatch & Not Synced"
                        : numberMismatch
                            ? "Delete Number Mismatch"
                            : "Delete Not Synced"}
                </div>
            </div>
        );
    };
    return (
        <React.Fragment>
            {/* FILTER CARD */}
            <div style={filterCardStyle}>
                <Row style={{ rowGap: "14px" }}>
                    {isSCMParty && (
                        <Col sm="3">
                            <Label style={filterFieldLabelStyle}>Party</Label>
                            <Select
                                value={PartyDropdown}
                                isSearchable
                                classNamePrefix="dropdown"
                                isDisabled={Distributor.length === 0}
                                options={[
                                    allLabelWithZero,
                                    ...Distributor.map(i => ({
                                        value: i.id,
                                        label: i.Name,
                                    }))
                                ]}
                                onChange={partyOnchange}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{ ...statusSelectStyles, ...partySelectStyles }}
                            />
                        </Col>
                    )}

                    <Col sm="3">
                        <Label style={filterFieldLabelStyle}>Version</Label>
                        <Select
                            value={versionFilter}
                            options={versionOptions}
                            isMulti
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            isOptionDisabled={(option) =>
                                versionFilter.some(selected => selected.value === option.value)
                            }
                            onChange={(selected) => setVersionFilter(selected || [])}
                            classNamePrefix="dropdown"
                            closeMenuOnScroll={true}
                            menuPosition="absolute"
                            placeholder="All versions"
                            styles={{ ...statusSelectStyles }}
                        />
                    </Col>

                    {/* Server Machine + Go are top-aligned with a hidden label
                        spacer so they stay pinned to the top of the row and
                        never sink downward when Status/Version grow taller
                        from multi-select chips wrapping onto a second line. */}
                    <Col sm="2" className="d-flex align-items-start">
                        <div style={{ width: "100%" }}>
                            <Label style={{ ...filterFieldLabelStyle, visibility: "hidden" }}>
                                Server Machine
                            </Label>
                            <div className="d-flex align-items-center" style={{ height: "38px" }}>
                                <input
                                    id="serverMachine"
                                    type="checkbox"
                                    checked={showServerOnly}
                                    onChange={(e) => setShowServerOnly(e.target.checked)}
                                    style={serverMachineCheckboxStyle}
                                />
                                <Label
                                    htmlFor="serverMachine"
                                    className="mb-0"
                                    style={serverMachineLabelStyle}
                                >
                                    Server Machine
                                </Label>
                            </div>
                        </div>
                    </Col>

                    <Col sm="1" className="d-flex align-items-start ms-auto">
                        <div style={{ width: "100%" }}>
                            <Label style={{ ...filterFieldLabelStyle, visibility: "hidden" }}>Go</Label>
                            <C_Button
                                type="button"
                                spinnerColor="white"
                                loading={GoBtnLoading === "Print"}
                                onClick={() => goButtonHandler("Print")}
                                style={{ ...goButtonStyle, width: "100%" }}
                            >
                                Go
                            </C_Button>
                        </div>
                    </Col>
                </Row>

            </div>

            {/* SUMMARY / VIEW-SWITCHER CARDS
                These are the page's tabs — click a card to filter the list
                below to that group. Ordered exactly as read left-to-right:
                Needs Attention -> Running OK -> Offline -> All Machines,
                each with a plain-language line explaining what it means so
                someone unfamiliar with the page can follow at a glance. */}
            {hasSearched && summaryStats.total > 0 && (
                <div style={summaryStripStyle}>
                    {[
                        {
                            key: "attention",
                            tone: "warning",
                            icon: "bx-error-circle",
                            label: "Needs Attention",
                            desc: "Machines with an issue to check",
                            // Always the fixed leftover-pool count — never changes when a
                            // sub-tab is clicked.
                            count: needsAttentionTotal,
                        },
                        {
                            key: "offline",
                            tone: "danger",
                            icon: "bx-wifi-off",
                            label: "Offline",
                            desc: "Not connected right now",
                            count: summaryStats.offline,
                        },
                        {
                            key: "ok",
                            tone: "success",
                            icon: "bx-check-circle",
                            label: "Running OK",
                            desc: "Working normally, nothing to do",
                            count: summaryStats.ok,
                        },
                        {
                            key: "all",
                            tone: "neutral",
                            icon: "bx-devices",
                            label: "All Machines",
                            desc: "Everything, healthy or not",
                            count: allMachinesScopedData.length,
                        },
                    ].map((card) => {
                        const isActive = activeTab === card.key;
                        return (
                            <div
                                key={card.key}
                                role="button"
                                tabIndex={0}
                                aria-pressed={isActive}
                                style={getSummaryCardStyle(card.tone, isActive)}
                                onClick={() => setActiveTab(card.key)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault();
                                        setActiveTab(card.key);
                                    }
                                }}
                                onMouseEnter={(e) => {
                                    if (!isActive) Object.assign(e.currentTarget.style, summaryCardHoverStyle);
                                }}
                                onMouseLeave={(e) => {
                                    if (!isActive) e.currentTarget.style.boxShadow = "0 2px 10px rgba(17,24,39,0.04)";
                                }}
                            >
                                {isActive && <div style={getSummaryCardAccentStyle(card.tone)}></div>}
                                <div style={getSummaryIconChipStyle(card.tone)}>
                                    <i className={`bx ${card.icon}`}></i>
                                </div>
                                <div style={summaryCardTextWrapStyle}>
                                    <div style={summaryCardLabelStyle}>
                                        {card.label}
                                        {isActive && <i className="bx bx-check-circle" style={{ color: colors.primary, fontSize: "14px" }}></i>}
                                    </div>
                                    <div style={getSummaryCardValueStyle(card.tone)}>{card.count}</div>
                                    <div style={summaryCardDescStyle}>{card.desc}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
            {/* ATTENTION SUB-TABS — only visible while "Needs Attention" is active */}
            {activeTab === "attention" && hasSearched && summaryStats.total > 0 && (() => {
                const regularOptions = attentionSubTabOptions.filter(o => o.key !== "billTimeWise");
                const billTimeOption = attentionSubTabOptions.find(o => o.key === "billTimeWise");

                const pillBase = {
                    borderRadius: "999px",
                    fontSize: "13px",
                    fontWeight: 600,
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    lineHeight: 1.2,
                    transition: "background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
                };

                const countBadge = (isActive, count, activeBg, idleBg, idleColor) => (
                    <span
                        aria-hidden="true"
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: "18px",
                            height: "18px",
                            padding: "0 5px",
                            borderRadius: "999px",
                            background: isActive ? activeBg : idleBg,
                            color: isActive ? "#fff" : idleColor,
                            fontSize: "11px",
                            fontWeight: 700,
                            lineHeight: 1,
                        }}
                    >
                        {count}
                    </span>
                );

                const clearIcon = (
                    <span
                        aria-hidden="true"
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "16px",
                            height: "16px",
                            borderRadius: "50%",
                            background: "rgba(255,255,255,0.2)",
                            fontSize: "14px",
                            lineHeight: 1,
                        }}
                    >
                        &times;
                    </span>
                );

                const billTimeActive = attentionSubTab === "billTimeWise";

                return (
                    <div style={{ margin: "0 0 14px" }}>
                        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", alignItems: "center" }}>

                            {/* Normal sub-tabs — these make up the Needs Attention total */}
                            {regularOptions.map((opt) => {
                                const isActive = attentionSubTab === opt.key;
                                const count = attentionSubTabCounts[opt.key] || 0;
                                return (
                                    <button
                                        key={opt.key}
                                        type="button"
                                        onClick={() => setAttentionSubTab(isActive ? "all" : opt.key)}
                                        title={isActive ? "Click to clear" : opt.label}
                                        style={{
                                            ...pillBase,
                                            padding: isActive ? "6px 10px 6px 14px" : "6px 14px",
                                            border: `1px solid ${isActive ? colors.primary : colors.gray200}`,
                                            background: isActive ? colors.primary : "#fff",
                                            color: isActive ? "#fff" : (colors.gray700 || "#374151"),
                                            boxShadow: isActive ? "0 4px 10px rgba(81,86,190,0.18)" : "none",
                                        }}
                                    >
                                        {opt.label}
                                        {countBadge(isActive, count, "rgba(255,255,255,0.25)", colors.gray100 || "#f3f4f6", colors.gray700 || "#374151")}
                                        {isActive && clearIcon}
                                    </button>
                                );
                            })}

                            {/* Divider + separate Bill Time Wise pill */}
                            {billTimeOption && (
                                <>
                                    <span
                                        aria-hidden="true"
                                        style={{ width: "1px", height: "24px", background: colors.gray200, margin: "0 4px" }}
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setAttentionSubTab(billTimeActive ? "all" : "billTimeWise")}
                                        title={billTimeActive ? "Click to clear" : "Not included in the Needs Attention total"}
                                        style={{
                                            ...pillBase,
                                            padding: billTimeActive ? "6px 10px 6px 12px" : "6px 12px",
                                            border: `1px ${billTimeActive ? "solid" : "dashed"} #d97706`,
                                            background: billTimeActive ? "#d97706" : "#fffbeb",
                                            color: billTimeActive ? "#fff" : "#b45309",
                                            boxShadow: billTimeActive ? "0 4px 10px rgba(217,119,6,0.22)" : "none",
                                        }}
                                    >
                                        <i className="bx bx-time-five" style={{ fontSize: "14px" }}></i>
                                        {billTimeOption.label}
                                        {countBadge(
                                            billTimeActive,
                                            attentionSubTabCounts.billTimeWise || 0,
                                            "rgba(255,255,255,0.25)",
                                            "#fde68a",
                                            "#92400e"
                                        )}
                                        {billTimeActive && clearIcon}
                                    </button>
                                </>
                            )}
                        </div>

                        {billTimeActive && (
                            <div style={{ marginTop: "8px", fontSize: "12px", color: "#92400e" }}>
                                <i className="bx bx-info-circle" style={{ marginRight: "4px" }}></i>
                                Bill Time Wise machines are shown separately and are not counted in the Needs Attention total.
                            </div>
                        )}
                    </div>
                );
            })()}
            {/* RUNNING OK SUB-TABS */}
            {activeTab === "ok" && hasSearched && summaryStats.total > 0 && (
                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", margin: "0 0 14px" }}>
                    {[
                        { key: "all", label: "All", count: okSubTabCounts.all },
                        { key: "server", label: "Server", count: okSubTabCounts.server },
                        { key: "nonServer", label: "Non Server", count: okSubTabCounts.nonServer },
                    ].map((opt) => {
                        const isActive = okSubTab === opt.key;

                        return (
                            <button
                                key={opt.key}
                                type="button"
                                onClick={() => setOkSubTab(isActive ? "all" : opt.key)}
                                title={isActive ? "Click to clear" : opt.label}
                                style={{
                                    padding: isActive ? "6px 10px 6px 14px" : "6px 14px",
                                    borderRadius: "999px",
                                    border: `1px solid ${isActive ? colors.primary : colors.gray200
                                        }`,
                                    background: isActive ? colors.primary : "#fff",
                                    color: isActive
                                        ? "#fff"
                                        : (colors.gray700 || "#374151"),
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    lineHeight: 1.2,
                                    boxShadow: isActive
                                        ? "0 4px 10px rgba(81,86,190,0.18)"
                                        : "none",
                                    transition:
                                        "background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
                                }}
                            >
                                {opt.label}

                                <span
                                    aria-hidden="true"
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        minWidth: "18px",
                                        height: "18px",
                                        padding: "0 5px",
                                        borderRadius: "999px",
                                        background: isActive
                                            ? "rgba(255,255,255,0.25)"
                                            : (colors.gray100 || "#f3f4f6"),
                                        color: isActive
                                            ? "#fff"
                                            : (colors.gray700 || "#374151"),
                                        fontSize: "11px",
                                        fontWeight: 700,
                                        lineHeight: 1,
                                    }}
                                >
                                    {opt.count}
                                </span>

                                {isActive && (
                                    <span
                                        aria-hidden="true"
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "16px",
                                            height: "16px",
                                            borderRadius: "50%",
                                            background: "rgba(255,255,255,0.2)",
                                            fontSize: "14px",
                                            lineHeight: 1,
                                        }}
                                    >
                                        &times;
                                    </span>
                                )}
                            </button>
                        );
                    })}
                </div>
            )}
            {/* MACHINE LIST CARD — filtered by whichever card is selected above */}
            <div style={tableCardStyle}>
                {rows.length > 0 && (
                    <div style={listContainerStyle}>
                        {rows.map((row, rIdx) => {
                            const useSubTabChips = activeTab === "attention" && attentionSubTab && attentionSubTab !== "all";
                            // A sub-tab row should show only the reason that matched that sub-tab
                            // (with its real numbers/times), full detail stays in the modal.
                            const chips = useSubTabChips ? getSubTabChips(row, attentionSubTab) : getRowChips(row);
                            const statusChip = chips[0] || { text: "Needs Attention", tone: "warning" };
                            return (
                                <div
                                    key={rIdx}
                                    style={getRowCardStyle()}
                                    onClick={() => setSelectedRow(row)}
                                    onMouseEnter={(e) => Object.assign(e.currentTarget.style, rowCardHoverStyle)}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = "none";
                                        e.currentTarget.style.borderColor = colors.gray200;
                                    }}
                                >
                                    <div style={rowCardLeftStyle}>
                                        <span style={getRowStatusIconWrapStyle(statusChip.tone)}>
                                            <i className={`bx ${getStatusIconClass(statusChip.text, statusChip.tone)}`}></i>
                                        </span>
                                        <div>
                                            <div style={rowCardNameStyle}>
                                                {getPartyDisplayName(row)}
                                            </div>
                                            {row.MacAddress && (
                                                <div style={rowCardMacStyle}>{row.MacAddress}</div>
                                            )}
                                            {row.ClientID && (
                                                <div style={clientIdRowStyle}>
                                                    <span style={clientIdBadgeStyle}>
                                                        <i className="bx bx-hash" style={{ fontSize: "10px" }}></i>
                                                        ID: {row.ClientID}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div style={rowCardChipsStyle}>
                                        {chips.map((c, i) => (
                                            c.detail ? (
                                                <span key={i} style={getStatusBadgeDetailedStyle(c.tone)} title={c.title || undefined}>
                                                    <span style={statusBadgeTopRowStyle}>
                                                        <i className={`bx ${getStatusIconClass(c.text, c.tone)}`} style={getStatusIconStyle(c.tone)}></i>
                                                        {c.text}
                                                    </span>
                                                    <span style={statusBadgeDetailTextStyle}>{c.detail}</span>
                                                </span>
                                            ) : (
                                                <span key={i} style={getStatusBadgeStyle(c.tone)} title={c.title || undefined}>
                                                    <i className={`bx ${getStatusIconClass(c.text, c.tone)}`} style={getStatusIconStyle(c.tone)}></i>
                                                    {c.text}
                                                </span>
                                            )
                                        ))}
                                    </div>

                                    <i className="bx bx-chevron-right" style={rowChevronStyle}></i>
                                </div>
                            );
                        })}
                    </div>
                )}

                {rows.length === 0 && (() => {
                    // Nothing typed in search / no version filter narrowing
                    // things down means the empty list genuinely reflects
                    // the selected card, so we can give a tab-specific,
                    // plain-language message instead of a generic one.
                    const isUnfiltered = !searchText
                    const isGoodNews =
                        isUnfiltered &&
                        hasSearched &&
                        summaryStats.total > 0 &&
                        (activeTab === "attention" || activeTab === "offline");

                    if (isGoodNews) {
                        return (
                            <div style={emptyStateSuccessStyle}>
                                <i className="bx bx-check-shield" style={{ fontSize: "28px", display: "block", marginBottom: "8px", color: colors.success }}></i>
                                {activeTab === "attention"
                                    ? "All machines are running fine — nothing needs attention"
                                    : "No machines are offline right now"}
                            </div>
                        );
                    }

                    return (
                        <div style={emptyStateStyle}>
                            <i className="bx bx-inbox" style={{ fontSize: "28px", display: "block", marginBottom: "8px" }}></i>
                            {isUnfiltered && activeTab === "ok"
                                ? "No machines are running OK right now"
                                : "Items Not Available"}
                        </div>
                    );
                })()}
            </div>

            {/* DETAIL MODAL — everything the compact row doesn't have room for */}
            <Modal isOpen={!!selectedRow} toggle={() => setSelectedRow(null)} centered scrollable>
                {selectedRow && (
                    <>
                        <div style={modalHeaderStyle}>
                            <div>
                                <div style={modalTitleStyle}>
                                    {getPartyDisplayName(selectedRow)}
                                </div>
                                {selectedRow.MacAddress && (
                                    <div style={rowCardMacStyle}>{selectedRow.MacAddress}</div>
                                )}
                            </div>
                            <button
                                type="button"
                                style={modalCloseButtonStyle}
                                onClick={() => setSelectedRow(null)}
                                aria-label="Close"
                            >
                                &times;
                            </button>
                        </div>

                        <ModalBody style={{ padding: 0 }}>
                            <div style={modalBodyWrapStyle}>
                                <div>
                                    <div style={modalSectionTitleStyle}>Status</div>
                                    <div style={modalChipsRowStyle}>
                                        {getRowChips(selectedRow).map((c, i) => (
                                            c.detail ? (
                                                <span key={i} style={getStatusBadgeDetailedStyle(c.tone)} title={c.title || undefined}>
                                                    <span style={statusBadgeTopRowStyle}>
                                                        <i className={`bx ${getStatusIconClass(c.text, c.tone)}`} style={getStatusIconStyle(c.tone)}></i>
                                                        {c.text}
                                                    </span>
                                                    <span style={statusBadgeDetailTextStyle}>{c.detail}</span>
                                                </span>
                                            ) : (
                                                <span key={i} style={getStatusBadgeStyle(c.tone)}>
                                                    <i className={`bx ${getStatusIconClass(c.text, c.tone)}`} style={getStatusIconStyle(c.tone)}></i>
                                                    {c.text}
                                                </span>
                                            )
                                        ))}
                                    </div>
                                </div>

                                {hasColumn("CreatedOnList") && renderCreatedOnSection(selectedRow) && (
                                    <div>
                                        <div style={modalSectionTitleStyle}>Last Synced</div>
                                        {renderCreatedOnSection(selectedRow)}
                                    </div>
                                )}

                                {hasColumn("Versions") && renderVersionsSection(selectedRow) && (
                                    <div>
                                        <div style={modalSectionTitleStyle}>Versions</div>
                                        {renderVersionsSection(selectedRow)}
                                    </div>
                                )}

                                {hasColumn("InvoiceCreatedOn") && renderInvoiceMismatchSection(selectedRow) && (
                                    <div>
                                        <div style={modalSectionTitleStyle}>Invoice Created</div>
                                        {renderInvoiceMismatchSection(selectedRow)}
                                    </div>
                                )}

                                {hasColumn("DeletedInvoiceCreatedOn") && renderDeleteMismatchSection(selectedRow) && (
                                    <div>
                                        <div style={modalSectionTitleStyle}>Invoice Deleted</div>
                                        {renderDeleteMismatchSection(selectedRow)}
                                    </div>
                                )}

                                {getVisibleBadges(selectedRow.VersionMismatchList).length > 0 && (
                                    <div>
                                        <div style={modalSectionTitleStyle}>Additional Flags</div>
                                        <div style={modalChipsRowStyle}>
                                            {getVisibleBadges(selectedRow.VersionMismatchList).map((s, i) => (
                                                <span key={i} style={getStatusBadgeStyle(getStatusTone(s))}>
                                                    <i className={`bx ${getStatusIconClass(s, getStatusTone(s))}`} style={getStatusIconStyle(getStatusTone(s))}></i>
                                                    {s}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </ModalBody>
                    </>
                )}
            </Modal>
        </React.Fragment>
    );
};

export default POSDashBoard;
